'use client';

import {useContext, useMemo} from 'react';
import {ActiveScreenIdSubscriptionContext} from './ActiveScreenIdProvider';

/**
 * Returns a stable function to toggle a screen id in/out of the selection.
 *
 * - If the id is not currently selected, it is prepended (becomes primary).
 * - If it is already selected, it is removed.
 */
export function useToggleScreenSelected(): (id: string) => void {
  const {setSelectedScreenIds} = useContext(ActiveScreenIdSubscriptionContext);
  return useMemo(
    () => (id: string) => {
      setSelectedScreenIds((prev) => {
        const idx = prev.indexOf(id);
        return idx === -1 ? [id, ...prev] : prev.filter((i) => i !== id);
      });
    },
    [setSelectedScreenIds],
  );
}
